import React from "react";
import {
  Menu as MuiMeniu,
  MenuItem,
  ListItemIcon,
  Typography,
  PopoverVirtualElement,
} from "@mui/material";
import { useMenuStyles } from "./css";

interface IMenu {
  data: { name: string; onClick?: () => void; icon?: React.ReactNode }[];
  open: boolean;
  onClose: () => void;
  onExited?: () => void;
  anchorEl:
    | Element
    | (() => Element)
    | PopoverVirtualElement
    | (() => PopoverVirtualElement)
    | null
    | undefined;
  transformOrigin?: {
    vertical: "top" | "bottom";
    horizontal: "left" | "right";
  };
}

function Menu(props: IMenu) {
  const { data, open, onClose, onExited, anchorEl, transformOrigin } = props;
  const { classes } = useMenuStyles();

  const handleItemClick = (item: {
    name: string;
    onClick?: () => void;
    icon?: React.ReactNode;
  }) => {
    if (item.onClick) {
      item.onClick();
    }
  };

  return (
    <MuiMeniu
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      transformOrigin={transformOrigin}
      classes={{ root: classes.root }}
      slotProps={{ transition: { onExited } }}
    >
      {data.map((item) => (
        <MenuItem onClick={() => handleItemClick(item)} key={item.name}>
          {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
          <Typography variant="inherit" noWrap>
            {item.name}
          </Typography>
        </MenuItem>
      ))}
    </MuiMeniu>
  );
}

export default Menu;
